import { SxProps, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const rootSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: 0, width: '100%', minHeight: 1306, backgroundColor: '#F9FAFB' };

export const innerSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '24px 24px 0px', gap: '24px', width: 964 };

export const headerBoxSx: SystemStyleObject<Theme> = { width: 964 };
export const titleSx: SystemStyleObject<Theme> = { fontFamily: 'Inter, Arial, sans-serif', fontWeight: 700, fontSize: 20, color: '#111827' };
export const subtitleSx: SystemStyleObject<Theme> = { mt: 1, fontSize: 13, color: '#6B7280' };

export const columnsWrapperSx: SystemStyleObject<Theme> = { display: 'flex', gap: 4, width: 964 };
export const leftColSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 4, width: 720 };

export const paperSx: SystemStyleObject<Theme> = { boxSizing: 'border-box', display: 'flex', flexDirection: 'column', padding: '21px', gap: 0, width: '100%', background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '14px' };
export const profileTitleSx: SystemStyleObject<Theme> = { fontFamily: 'Inter, Arial, sans-serif', fontWeight: 600, fontSize: '14px', lineHeight: '21px', letterSpacing: '-0.15px', mb: 3 };

export const avatarContainerSx: SystemStyleObject<Theme> = { position: 'relative', width: 64, height: 64 };
export const avatarSx: SystemStyleObject<Theme> = { width: 56, height: 56, bgcolor: '#143133', boxShadow: '0 0 0 2px #E5E7EB' };
export const cameraButtonSx: SystemStyleObject<Theme> = { position: 'absolute', right: 0, bottom: 0, width: 24, height: 24, bgcolor: '#39A9B1', border: '2px solid #FFFFFF', color: '#FFFFFF', '&:hover': { bgcolor: '#2e8f88' }, p: 0 };

export const infoBlockSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 0, width: '110px' };
export const nameSx: SystemStyleObject<Theme> = { fontWeight: 600, fontSize: 15 };
export const emailSx: SystemStyleObject<Theme> = { fontSize: 12, color: '#9CA3AF' };
export const adminBadgeSx: SystemStyleObject<Theme> = { mt: 0, background: '#EFF6FF', border: '1px solid #BFFBFF', borderRadius: 9999, px: 1.5, display: 'inline-flex', alignItems: 'center' };
export const adminIconSx: SystemStyleObject<Theme> = { width: 9, height: 9, color: '#39A9B1', mr: 1 };
export const adminTextSx: SystemStyleObject<Theme> = { fontSize: 10, fontWeight: 600, color: '#39A9B1' };

export const fieldsRowSx: SystemStyleObject<Theme> = { display: 'flex', gap: 15, mt: 3, width: '100%' };
export const fieldColSx = (width = 272.5): SystemStyleObject<Theme> => ({ display: 'flex', flexDirection: 'column', gap: 0, width });
export const fieldLabelSx: SystemStyleObject<Theme> = { fontFamily: 'Inter, Arial, sans-serif', fontWeight: 500, fontSize: '13px', lineHeight: '19.5px', letterSpacing: '-0.08px', color: '#374151' };

export const inputSx: SystemStyleObject<Theme> = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        height: '41.5px',
        borderRadius: '10px',
        '& fieldset': { borderWidth: '1px' }
    },
    '& .MuiOutlinedInput-input': { padding: '10px 12px' }
};

export const disabledInputSx: SystemStyleObject<Theme> = { background: '#F9FAFB' };

export const saveButtonSx: SystemStyleObject<Theme> = {
    background: '#39A9B1',
    color: '#FFFFFF',
    borderRadius: '10px',
    textTransform: 'none',
    fontFamily: 'Inter, Arial, sans-serif',
    fontWeight: 600,
    fontSize: '13px',
    lineHeight: '19.5px',
    letterSpacing: '-0.08px',
    textAlign: 'center',
    px: '20px',
    py: '10px'
};

export const changePaperSx: SystemStyleObject<Theme> = { boxSizing: 'border-box', display: 'flex', flexDirection: 'column', width: '100%', background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '14px' };
export const changeInnerSx: SystemStyleObject<Theme> = { p: 2 };
export const changeTitleSx: SystemStyleObject<Theme> = { fontFamily: 'Inter, Arial, sans-serif', fontWeight: 600, fontSize: '14px', lineHeight: '21px', letterSpacing: '-0.15px' };
export const changeHelperSx: SystemStyleObject<Theme> = { fontSize: 12, color: '#9CA3AF', mb: 0, mt: 1 };
export const formSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 0, width: '100%', mt: 2 };
export const passwordFieldSx: SystemStyleObject<Theme> = inputSx;
export const updateButtonSx: SystemStyleObject<Theme> = saveButtonSx;

export const recentPaperSx: SystemStyleObject<Theme> = { boxSizing: 'border-box', padding: 0, width: 264, background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '14px', p: 2 };
export const recentTitleSx: SystemStyleObject<Theme> = { fontWeight: 600, fontSize: 14 };
export const activityRowSx: SystemStyleObject<Theme> = { display: 'flex', gap: 1, alignItems: 'flex-start' };
export const bulletSx: SystemStyleObject<Theme> = { width: 6, height: 6, borderRadius: '16777200px', bgcolor: '#39A9B1', opacity: 1, position: 'relative', top: '5px' };

export default {};
